import { FormattedMessage } from 'react-intl';
import {
  TotalBarSummaryBody,
  TotalBarSummary,
  TotalBarSummaryDivider
} from 'components/TotalsBar';
import {
  TotalBarSummaryWithTitle,
  TotalBarTitle
} from 'components/TotalsBar/styled';
import { getRCCTotalsInFooter } from './helpers';
import { ReconciliationReportDataType } from './types';

export const TotalBarFooter = ({
  data,
  selectedReconcileRecords
}: {
  data: ReconciliationReportDataType[] | undefined;
  selectedReconcileRecords: ReconciliationReportDataType[];
}): React.JSX.Element => {
  const {
    totalPending,
    totalSettled,
    totalVoided,
    totalReconciled,
    selectedTotal,
    totalAmount
  } = getRCCTotalsInFooter(data, selectedReconcileRecords);
  return (
    <TotalBarSummaryWithTitle>
      <TotalBarTitle />
      <TotalBarSummary>
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Pending"
              description="Total Bar Pending Total"
            />
          }
          value={totalPending}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Settled"
              description="Total Bar Settled Total"
            />
          }
          value={totalSettled}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Void"
              description="Total Bar Void Total"
            />
          }
          value={totalVoided}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Reconciled"
              description="Total Bar Reconciled Total"
            />
          }
          value={totalReconciled}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Selected Total"
              description="Selected Total"
            />
          }
          value={selectedTotal}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          highlighted
          title={
            <FormattedMessage defaultMessage="Total" description="Total" />
          }
          value={totalAmount}
        />
      </TotalBarSummary>
    </TotalBarSummaryWithTitle>
  );
};
